// images references in the manifest
import "../../../assets/icon-16.png";
import "../../../assets/icon-32.png";
import "../../../assets/icon-64.png";
import "../../../assets/icon-80.png";
import "../../../assets/icon-128.png";
import "../../../assets/logo-filled.png";
import "../../../assets/logoGit.png";

import { Spinner, SpinnerSize } from "@fluentui/react";
import { Routes } from "@taskpane/routes";
import React from "react";
import { HashRouter as TaskPaneRouter } from "react-router-dom";
export interface AppProps {
  isOfficeInitialized: boolean;
}

export const App = ({ isOfficeInitialized }: AppProps) => {
  if (!isOfficeInitialized) {
    return (
      <div className="h-100 d-flex flex-column">
        <Spinner size={SpinnerSize.large} className="align-self-center" />
      </div>
    );
  }

  return (
    <TaskPaneRouter basename="/taskpane">
      <Routes />
    </TaskPaneRouter>
  );
};
